import { Row, Col, Panel, Whisper, Popover, DateRangePicker, IconButton } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import FunnelIcon from '@rsuite/icons/Funnel';

export default function DashboardHeader({selectedDate, setSelectedDate}) {
    
    const settingsSpeaker = (
        <Popover className="settings-popover" title="Фильтры">
            Для текущей страницы фильтров нет
        </Popover>
      );

    return (
        <div className="dashboard-header">
            <DateRangePicker value={selectedDate} onChange={setSelectedDate}
                className="dashboard-date-picker" appearance="subtle"
                placeholder="Выберите дату" cleanable={false} />
            <Whisper placement="bottomEnd" speaker={settingsSpeaker} trigger="click">
                <IconButton icon={<FunnelIcon />} />
            </Whisper>
            
        </div>
    )
}